export const OUSDaiUtilityAbi = [
  {
    type: "function",
    name: "addWhitelistedOAdapters",
    inputs: [
      {
        name: "oAdapters",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "localCompose",
    inputs: [
      {
        name: "actionType",
        type: "uint8",
        internalType: "enum IOUSDaiUtility.ActionType",
      },
      {
        name: "depositToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "depositAmount",
        type: "uint256",
        internalType: "uint256",
      },
      { name: "data", type: "bytes", internalType: "bytes" },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "removeWhitelistedOAdapters",
    inputs: [
      {
        name: "oAdapters",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "rescue",
    inputs: [
      { name: "token", type: "address", internalType: "address" },
      { name: "to", type: "address", internalType: "address" },
      { name: "amount", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "ActionFailed",
    inputs: [
      {
        name: "action",
        type: "string",
        indexed: true,
        internalType: "string",
      },
      {
        name: "reason",
        type: "bytes",
        indexed: false,
        internalType: "bytes",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ComposerDeposit",
    inputs: [
      {
        name: "dstEid",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "depositToken",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "depositAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "usdaiAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ComposerDepositAndStake",
    inputs: [
      {
        name: "dstEid",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "depositToken",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "depositAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "usdaiAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "susdaiAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ComposerQueuedDeposit",
    inputs: [
      {
        name: "queueType",
        type: "uint8",
        indexed: true,
        internalType: "enum IUSDaiQueuedDepositor.QueueType",
      },
      {
        name: "depositToken",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "depositAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ComposerStake",
    inputs: [
      {
        name: "dstEid",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "usdaiAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "susdaiAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "WhitelistedOAdaptersAdded",
    inputs: [
      {
        name: "oAdapters",
        type: "address[]",
        indexed: false,
        internalType: "address[]",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "WhitelistedOAdaptersRemoved",
    inputs: [
      {
        name: "oAdapters",
        type: "address[]",
        indexed: false,
        internalType: "address[]",
      },
    ],
    anonymous: false,
  },
  { type: "error", name: "DepositAndStakeFailed", inputs: [] },
  { type: "error", name: "DepositFailed", inputs: [] },
  { type: "error", name: "InvalidAddress", inputs: [] },
  { type: "error", name: "InvalidDepositToken", inputs: [] },
  { type: "error", name: "QueuedDepositFailed", inputs: [] },
  { type: "error", name: "StakeFailed", inputs: [] },
  { type: "error", name: "UnknownAction", inputs: [] },
] as const;
